import React, { Component } from 'react';
import {
  equals,
  pathOr,
} from 'ramda';
import { graphql, compose, Query } from 'react-apollo';
import PropTypes from 'prop-types';
import ApplicationTable from './ApplicationTable';
import LoadingPanel from './Loading';
import { debounce } from '../../utils';
import {
  getAllApplications,
  GET_USER_APPLICATION_COUNT,
} from './queries';
import TeamProvider, { TeamContext } from '../TeamProvider';

class ApplicationsProvider extends Component {
  state = {
    searchTxt: '',
    currentPage: 1,
    recordsPerPage: 5,
    skip: 0,
    filter: '',
  };


  getOwner = () => {
    const { env } = this.props;

    return equals(undefined, env)
      ? TeamContext.getSelectedTeamId()
      : 'allApplications';
  }

  onChangeInput = (e) => {
    this.setState({ searchTxt: e.target.value }, () => {
      debounce(() => {
        this.setState(prevState => ({
          filter: prevState.searchTxt,
        }));
      }, 500)();
    });
  };

  onClickPage = (page) => {
    const {
      recordsPerPage,
    } = this.state;
    const newSkip = recordsPerPage * (page - 1);
    this.setState({
      currentPage: page,
      skip: newSkip,
    });
  };

  render() {
    const {
      currentPage,
      recordsPerPage,
      searchTxt,
      skip,
      filter,
    } = this.state;

    const {
      user,
      env,
    } = this.props;

    return (
      <div>
        <Query
          query={getAllApplications}
          notifyOnNetworkStatusChange
          fetchPolicy="network-only"
          variables={{
            filter, skip, limit: recordsPerPage, owner: this.getOwner(),
          }}
        >
          {({
            data, loading, error, refetch,
          }) => (
            <Query
              query={GET_USER_APPLICATION_COUNT}
              notifyOnNetworkStatusChange
              fetchPolicy="network-only"
            >
              {({
                data: countData, loading: countLoading, error: countError, refetch: countRefetch,
              }) => {
                if (error || countError) {
                  return <h1>Oops, got error...</h1>;
                }

                const personalApplicationCount = (countData.userApplicationCount) ? (countData.userApplicationCount.length > 0) ? countData.userApplicationCount[0].applicationCount : 0 : 0;

                const requestRefetch = () => {
                  refetch();
                  countRefetch();
                };

                const allApplications = pathOr([], ['allApplications', 'applications'], data);

                return (
                  <TeamProvider user={user}>
                    <TeamContext.Consumer>
                      {selectedTeam => (
                        <ApplicationTable
                          {...this.props}
                          key={selectedTeam}
                          selectedTeam={TeamContext.getSelectedTeamId()}
                          personalApplicationCount={personalApplicationCount}
                          applications={loading ? [] : allApplications}
                          isLoading={loading}
                          recordsPerPage={recordsPerPage}
                          currentPage={currentPage}
                          onChangeInput={this.onChangeInput}
                          onClickPage={this.onClickPage}
                          searchTxt={searchTxt}
                          applicationCount={loading ? 0 : data.allApplications.count}
                          refetch={requestRefetch}
                        />
                      )}
                    </TeamContext.Consumer>
                  </TeamProvider>
                );
              }}
            </Query>
          )}
        </Query>
      </div>
    );
  }
}


export default ApplicationsProvider;
